module Meevo.Plugins.BasicEmailMarketing {
    export class AmountFilterModalController {
        static $inject = [
            '$mdDialog'
        ];

        public amountModel: IAmountModel;
        public isAllSelectedService: boolean;
        public isAllSelectedProduct: boolean;
        public isAllSelectedEmployee: boolean;
        public productCriteria: any = {
            includeBundles: true
        };

        get showServices(): boolean {
            return this.amountModel.amountItemType === AmountItemTypeEnum.Services
                || this.amountModel.amountItemType === AmountItemTypeEnum.ServicesAndProducts;
        }

        get showProducts(): boolean {
            return this.amountModel.amountItemType === AmountItemTypeEnum.Products
                || this.amountModel.amountItemType === AmountItemTypeEnum.ServicesAndProducts;

        }

        constructor(private $mdDialog: ng.material.IDialogService) {
        }

        public clear(): void {
          this.isAllSelectedService = true;
          this.isAllSelectedProduct = true;
          this.isAllSelectedEmployee = true;
        }

        public close(): void {
            this.$mdDialog.cancel();
        }

        public ok(): void {
            this.$mdDialog.hide(this.amountModel);
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .controller('meevo.plugins.basicEmailMarketing.AmountFilterModalController', AmountFilterModalController);


}
